import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentEvaluation from "./routes/StudentEvaluation";
import AssessmentInsight from "./routes/AssessmentInsight";
export default store => ({
  path: ":evaluationId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "assessment-evaluation" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [AssessmentInsight(store), StudentEvaluation(store)],
});
